import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useLoading } from '@/providers/LoadingProvider';
import { useCreateBusinessPartner } from '@/hooks/api/0450_create_business_partner';
import { useInvalidateBusinessPartners } from '@/hooks/api/0430_business_partners';
import { toastSuccess } from '@/lib/toast';
import { useBusinessPartnerContexts } from '@/hooks/api/0440_business_partner_contexts';
import { ApiErrorMessages } from '@/components/element/ApiErrorMessages';
import { BusinessPartnerCreateForm } from '@/components/features/BusinessPartnerCreateForm';
import { BusinessPartner } from '@/hooks/api/models';

export const WorkspaceBusinessPartnersNew = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('新規取引先登録'), []);
  useEffect(
    () => setBreadcrumbs([{ label: `取引先設定`, path: `/w/${_w_!.identifier}/setting/business_partners` }]),
    []
  );

  const navigate = useNavigate();
  const { _w_ } = useCurrentWorkspace();
  const { invalidate } = useInvalidateBusinessPartners(_w_!.identifier);
  const submitButtonRef = useRef<HTMLButtonElement>(null);

  const onCreated = (businessPartner: BusinessPartner) => {
    invalidate(); // 取引先のキャッシュクリア
    navigate(`/w/${_w_!.identifier}/setting/business_partners`);
  };

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'business_partner'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-1">新規取引先登録</h5>
                  <p className="text-xs mb-0">
                    登録したい取引先の法人番号を入力すると企業名等が自動設定されます。
                    <br />
                    法人番号は
                    <Link
                      to="https://www.houjin-bangou.nta.go.jp/"
                      className="text-decoration-underline"
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      法人番号公表サイト
                    </Link>
                    で検索することができます。
                  </p>
                </div>
              </div>
              <div className="card-body pt-0">
                <BusinessPartnerCreateForm onCreated={onCreated} submitButtonRef={submitButtonRef} />
              </div>
              <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                <Link to={`/w/${_w_!.identifier}/setting/business_partners`} className="btn btn-outline-secondary me-2">
                  戻る
                </Link>
                <button
                  type="button"
                  className="btn bg-gradient-dark btn-icon"
                  onClick={() => submitButtonRef.current?.click()}
                >
                  <i className="fas fa-check-circle"></i>新規登録する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
